"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _linkifyIt = _interopRequireDefault(require("linkify-it"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var REPLACEMENT_TEXT = '*'; // Strictly match dates, adapted to the usage of censorify:
// match everything but the schema, so we need to remove the leading digit in the regex
// This catches:
// 2019-01-01
// 01-01-2019
// 01-19
// 01/01/2019
// 01/01

var dateRe = /^((\d{3}[-/]\d{2}[-/]\d{2})|(\d{1}[-/]\d{2}[-/]\d{4})|(\d{0,1}[-/]\d{2}))/; // Lazily match phone numbers
// This is a very permissive regex to match as many phone number as possible
// If you find false positive open a new issue

var phoneRe = /^[0-9\-(). +]{6,}[0-9)]{1}\b/;

function CensorifyIt() {
  var _this = this;

  _linkifyIt["default"].call(this); // Match international format with leading +


  this.add('+', {
    validate: function validate(text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.phone) {
        self.re.phone = new RegExp(phoneRe);
      }

      if (!self.re.date) {
        self.re.date = new RegExp(dateRe);
      }

      if (self.re.phone.test(tail) && !self.re.date.test(tail)) {
        return tail.match(self.re.phone)[0].length;
      }

      return 0;
    }
  }); // Alias (123) 123 1234 to the previous rule

  this.add('(', '+'); // Alias fuzzy phone numbers

  Array.from(Array(10).keys()).map(function (_, i) {
    return _this.add(i.toString(), '+');
  });
  this.replacementText = REPLACEMENT_TEXT;
  this.exceptions = [];
}

CensorifyIt.prototype = Object.create(_linkifyIt["default"].prototype);

CensorifyIt.prototype.set = function set(_ref) {
  var _ref$exceptions = _ref.exceptions,
      exceptions = _ref$exceptions === void 0 ? [] : _ref$exceptions,
      _ref$replacementText = _ref.replacementText,
      replacementText = _ref$replacementText === void 0 ? REPLACEMENT_TEXT : _ref$replacementText,
      options = _objectWithoutProperties(_ref, ["exceptions", "replacementText"]);

  _linkifyIt["default"].prototype.set.call(this, options);

  this.exceptions = exceptions;
  this.replacementText = replacementText;
  return this;
};

function Match(match, text) {
  this.schema = match.schema;
  this.index = match.index;
  this.lastIndex = match.lastIndex;
  this.raw = match.text;
  this.url = match.url;
  this.text = text.trim();
}

CensorifyIt.prototype.matchExceptions = function matchExceptions(match) {
  return this.exceptions.some(function (exception) {
    if (exception instanceof Function) return exception(match);
    if (exception instanceof RegExp) return match.raw.match(exception);
    throw new Error("Exception should either be a Function or a RegExp, got ".concat(_typeof(exception)));
  });
};

CensorifyIt.prototype.replace = function replace() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  if (this.replacementText.length === 1) {
    return this.replacementText.repeat(length);
  }

  return this.replacementText;
};

CensorifyIt.prototype.match = function match(text) {
  var _this2 = this;

  if (!text) return [];

  var matches = _linkifyIt["default"].prototype.match.call(this, text);

  if (!matches) return [];
  return matches.map(function (match, i) {
    var replacement = _this2.matchExceptions(match) ? match.url : _this2.replace(match.raw.length);
    return new Match(match, replacement);
  });
};

CensorifyIt.prototype.process = function process(text) {
  return this.match(text).reduce(function (acc, match) {
    return acc.replace(match.raw, match.text);
  }, text);
};

var _default = CensorifyIt;
exports["default"] = _default;
//# sourceMappingURL=index.js.map